/**
 * The person's own credits, kept by the sandbox gateway (vfs-service src/gateway/billing, docs/billing.md), under the
 * vfs path the web app already uses, with the person's authorized fetch:
 * `GET /api/v1/me/credits` -> `{ chat, enforcement, started, status, limitedBy, balance: { scope, left, of, source },
 * scopes, spentThisMonth, burnRate, daysLeft, byUnit, warning: null | { level, scope }, rates }`.
 */
import config from '../config';
import { getAuthorizedFetch } from '../utils/fetchRegistry';
import { shareInflight } from '../utils/sharedRequest';

const base = () => (config.vfsServiceUrl || '').replace(/\/$/, '');

/** The person's credits, or null where the gateway has no billing (an older one, shared mode). Throws on any other failure. */
export function getMyCredits() {
  return shareInflight('my-credits', async() => {
    if (!base()) { return null; }
    const response = await getAuthorizedFetch()(`${base()}/api/v1/me/credits`, { headers: { Accept: 'application/json' } });
    if (response.status === 404) { return null; }
    const data = await response.json().catch(() => null);
    if (!response.ok) {
      const error = new Error(data?.error || `Request failed (${response.status})`);
      error.status = response.status;
      throw error;
    }
    return data && typeof data === 'object' ? data : null;
  });
}
